import { render, staticRenderFns } from "./RichWorkspace.vue?vue&type=template&id=c30b82a0&scoped=true"
import script from "./RichWorkspace.vue?vue&type=script&lang=js"
export * from "./RichWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RichWorkspace.vue?vue&type=style&index=0&id=c30b82a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30b82a0",
  null
  
)

export default component.exports